import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";
import { Flex, Heading, Text } from "theme-ui";
import { colors, typography } from "../../styles/theme";

const Customers = ({ region }) => {
  const { clientLogosIN, clientLogosLME, clientLogosSME } = useStaticQuery(graphql`
    query {
      clientLogosIN: file(relativePath: { eq: "home/client-logos.png" }) {
        childImageSharp {
          gatsbyImageData(width: 950, layout: CONSTRAINED)
        }
      }
      clientLogosLME: file(relativePath: { eq: "home/me-customers-logo-lg.png" }) {
        childImageSharp {
          gatsbyImageData(height: 72, layout: CONSTRAINED)
        }
      }
      clientLogosSME: file(relativePath: { eq: "home/me-customers-logo-mb.png" }) {
        childImageSharp {
          gatsbyImageData(width: 704, layout: CONSTRAINED)
        }
      }
    }
  `);

  let clientLogos = getImage(clientLogosIN);
  let imgStyle = {};

  if (region === "ME") {
    clientLogos = withArtDirection(getImage(clientLogosLME), [
      {
        media: "(max-width: 899px)",
        image: getImage(clientLogosSME),
      },
    ]);
    imgStyle = {
      justifyContent: "center",
      ".home-client-logos": {
        objectFit: "contain",
        "@media(max-width: 899px)": {
          width: "37.5rem",
          height: "11rem"
        },
        "@media(max-width: 599px)": {
          height: "5.938rem",
          width: "20rem"
        },
      }
    }
  }

  return (
    <Flex
      sx={{
        flexDirection: "column",
        gap: "3rem",
        alignItems: "center",
        justifyContent: "center",
        "@media screen and (min-width: 900px) and (max-width: 1280px)": {
          px: "4rem"
        },
      }}
    >
      <Heading as="h2" sx={{ textAlign: "center", ...typography.h2 }}>
        The
        <Text sx={{ color: colors.primary700 }}> customers </Text>
        have spoken
      </Heading>
      {clientLogos && <Flex sx={imgStyle}>
        <GatsbyImage image={clientLogos} className="home-client-logos" />
      </Flex>}
    </Flex>
  );
};

export default Customers;